/**
 * Perché ci si è ritrovati alla schermata di accesso.
 *
 * ## Il problema
 *
 * Cambiare la propria password chiude **tutte** le sessioni, compresa quella
 * in corso: è voluto, perché se si cambia temendo che qualcuno l'abbia
 * scoperta, lasciarne una viva vanifica l'operazione. La conseguenza però è
 * che da quel momento la sessione è morta, e la prima chiamata qualsiasi —
 * anche una di quelle che il contesto di autenticazione fa da solo quando si
 * torna sulla finestra — riceve un 401. `alDecaderedellaSessione` scatta,
 * l'utente diventa `null`, e l'applicazione mostra la schermata di accesso
 * **senza che nessuno l'abbia chiesto**.
 *
 * Chi ci arriva senza spiegazione pensa che l'applicazione sia caduta proprio
 * mentre stava cambiando la password — cioè nel momento peggiore per farsi
 * venire un dubbio.
 *
 * ## Il rimedio
 *
 * Una riga di testo lasciata qui prima di far cadere la sessione, che la
 * schermata di accesso raccoglie e mostra. Copre tutte e due le strade: sia
 * quella di chi preme «Vai all'accesso», sia quella di chi viene portato via
 * dalla rivalidazione automatica mentre sta ancora leggendo.
 *
 * ⚠️ È una variabile di modulo, non `localStorage` né `sessionStorage`, e non
 * per caso: deve vivere quanto la pagina aperta e non un minuto di più. Chi
 * ricarica il browser sta arrivando da capo, e trovarsi ancora scritto «hai
 * appena cambiato la password» il giorno dopo sarebbe soltanto confusione.
 */

let motivo: string | null = null;

/** Da chiamare **prima** di lasciare cadere la sessione. */
export function annunciaCongedo(testo: string): void {
  motivo = testo;
}

/**
 * Cosa dire a chi si trova davanti l'accesso. `null` = niente da spiegare, ci
 * è arrivato per la via normale.
 *
 * Non consuma il messaggio di proposito: leggerlo deve poter succedere a ogni
 * ridisegno senza che sparisca. A cancellarlo è l'accesso riuscito.
 */
export function leggiCongedo(): string | null {
  return motivo;
}

/** Si è rientrati: il motivo per cui si era usciti non serve più. */
export function dimenticaCongedo(): void {
  motivo = null;
}
